import React from 'react';

type Nullable<T> = T | null;

export function useModalAddOperation<T>() {
  const [openAddOperation, setAddOperation] = React.useState(false);
  const [editingItem, setEditingItem] = React.useState<Nullable<T>>(null);

  const handleOpenAddOperation = (item?: T) => {
    if (item !== undefined) {
      setEditingItem(item);
    }
    setAddOperation(true);
  };

  const handleCloseAddOperation = () => {
    setAddOperation(false);
    setEditingItem(null);
  };

  return {
    openAddOperation,
    handleOpenAddOperation,
    handleCloseAddOperation,
    editingItem,
    setEditingItem,
  };
}
